import React from "react";
import {Navbar,Footer} from '../hrcomponents';
import {useState,useEffect} from 'react';
import axios from "axios";
import configData from "../config.json";
import {useParams} from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import { format } from "date-fns";
import { leaves } from '../utils/datalist';

const Generate=()=>{
    if(localStorage.getItem('branchID')===null){
        window.location.replace('/hris');
    }

    return(
        <>
        <div className='container'>
            <Navbar/>
        
                <div className="card bg-default o-hidden h-100">
                <div className="card-title">Generate</div>
                <div className="card-body" style={{ backgroundColor: "lavenderblush", padding: "20px", borderRadius: "0px", fontSize:"12px" }}>                   
                    <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12"></div>
                </div>
                </div>
            <Footer/>
        </div>
        </>
    )
}

export default Generate;